export function arrayBufferToUTF8String(arrayBuffer: ArrayBufferLike): string {
  if (typeof TextDecoder !== 'undefined') {
    // claude eslint: TextDecoder.decode doesn't accept ArrayBufferLike in TS 5.7, but works at runtime
    return new TextDecoder('utf-8').decode(arrayBuffer as ArrayBuffer);
  }
  // React native doesn't have TextDecoder built in, so we have to decode UTF8 ourselves.
  // This code was generated by Claude Sonnet 3.5.
  const uint8Array = new Uint8Array(arrayBuffer);
  let result = '';
  let i = 0;

  while (i < uint8Array.length) {
    let codePoint;

    if (uint8Array[i] < 0x80) {
      codePoint = uint8Array[i++];
    } else if (uint8Array[i] < 0xe0) {
      codePoint = (uint8Array[i++] & 0x1f) << 6 | uint8Array[i++] & 0x3f;
    } else if (uint8Array[i] < 0xf0) {
      codePoint =
        (uint8Array[i++] & 0x0f) << 12 |
        (uint8Array[i++] & 0x3f) << 6 |
        uint8Array[i++] & 0x3f;
    } else {
      codePoint =
        (uint8Array[i++] & 0x07) << 18 |
        (uint8Array[i++] & 0x3f) << 12 |
        (uint8Array[i++] & 0x3f) << 6 |
        uint8Array[i++] & 0x3f;
    }

    // Convert code point to characters
    if (codePoint <= 0xffff) {
      result += String.fromCharCode(codePoint);
    } else {
      // Split into surrogate pairs for code points > U+FFFF
      codePoint -= 0x10000;
      result += String.fromCharCode(
        (codePoint >> 10) + 0xd800,
        (codePoint & 0x3ff) + 0xdc00,
      );
    }
  }

  return result;
}
